<script>
import { formatter } from '@/helpers/formatter'
export default {
  mixins: [formatter],
  props: {
    fileList: { type: Array },
    error: { type: String }
  },
  data: vm => ({
    showFileList: false,
    maxFileSize: vm.formatBytes(
      parseInt(window.config.VUE_APP_UPLOAD_MAX_FILE_SIZE)
    )
  })
}
</script>
<template>
  <v-list-item-content>
    <v-list-item-title class="error--text font-weight-bold">{{
        $t(`component.upload.alertDialogItem.${error}.title`)
      }}
    </v-list-item-title>
    <v-list-item-subtitle>
      <span v-html="$t(`component.upload.alertDialogItem.${error}`, { '{{MAX_FILE_SIZE}}': maxFileSize })"></span>
    </v-list-item-subtitle>
    <v-list-item-subtitle>
      <a @click="showFileList = !showFileList"
      ><span v-if="!showFileList"
      >{{ $t('component.upload.alertDialogItem.showFileList')
        }}<v-icon color="primary">mdi-menu-down</v-icon></span>
        <span v-else
        >{{ $t('component.upload.alertDialogItem.closeFileList')
          }}<v-icon class="pb-1" color="primary">mdi-menu-up</v-icon>
        </span></a>
      <v-expand-transition>
        <v-list
          v-if="showFileList"
          max-height="150"
          dense
          class="pt-0 pb-0 file-list">
          <v-list-item
            v-for="file in fileList"
            :key="file.name"
            class="file-list-item">
            <v-list-item-icon class="pa-0 pr-1 ma-0">
              <v-icon color="error" medium class="file-list-icon"
              >mdi-close</v-icon>
            </v-list-item-icon>
            <v-list-item-content class="pa-0 ma-0">
              <span class="text-truncate text-left">{{ file.name }}</span>
            </v-list-item-content>
          </v-list-item>
        </v-list>
      </v-expand-transition>
    </v-list-item-subtitle>
  </v-list-item-content>
</template>
<style lang="scss" scoped>
.file-list {
  overflow: auto;
  .file-list-icon::after {
    height: unset;
  }
  .file-list-item {
    min-height: 0px;
  }
}
</style>
